export const GET_ALL_JIT_USERS = 'GET_ALL_JIT_USERS';
export const GET_ALL_JIT_USERS_LOADING = 'GET_ALL_JIT_USERS_LOADING';
export const EXPIRE_RESERVATION = 'EXPIRE_RESERVATION';
export const JIT_USERS_COUNT = 'JIT_USERS_COUNT';